import { GET, POST } from './core';

export const getEndpointWithPrefix = (endpoint) => {
    return `/greetly/${endpoint}`;
};

export const getTransactionDetails = (token, greetlyId) => {
    const endpoint = getEndpointWithPrefix(`getGreetlyTransactions/${greetlyId}`);
    return GET(endpoint, token);
}

export const getGreetlyVouchers = (token, params) => {
    let endpoint = `getAllGreetlyDetails?page=${params.page}&pageSize=${params.pageSize}&sortBy=${params.sortBy}&order=${params.order}&isVoucherAvailable=true`;

    if (params.filterType && params.filterType !== 'ALL') {
        endpoint += `&filterType=${params.filterType}`;
    }

    if (params.startDate) {
        endpoint += `&startDate=${params.startDate}`;
    }

    if (params.endDate) {
        endpoint += `&endDate=${params.endDate}`;
    }

    return GET(getEndpointWithPrefix(endpoint), token);
};

export const getQrPdf = (request, token) => {
    const endpoint = getEndpointWithPrefix('getQrPdf');
    return POST(endpoint, request, token);
};

export const getGreetlyVouchersByFilters = (token, payload) => {
    const endpoint = getEndpointWithPrefix('getAllGreetlyDetailsByFilter');
    return POST(endpoint, payload, token);
};

export const handOverVoucher = (token, payload) => {
    const endpoint = getEndpointWithPrefix('setHandOverDate');
    return POST(endpoint, payload, token);
}

export const setPrintDate = (token, payload) => {
    const endpoint = getEndpointWithPrefix('setPrintDate');
    return POST(endpoint, payload, token);
}

export const getGreetlyCsv = (token, payload) => {
    const url = `${process.env.REACT_APP_MERCHANT_PORTAL_API}/v1.0/app${getEndpointWithPrefix('get-greetly-csv')}`;
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    }).then(response => {
        if (response.status >= 400) {
            return response.json().then(err => Promise.reject(err));
        }
        return response.blob();
    });
};